import { observer } from "mobx-react-lite";
import { Button, Center } from "@chakra-ui/react";
import { langStore, translate, useSelecting } from "@noli/business";
import SubEditorPanel from "@/components/SubPanel/SubEditor";
import { ImageBusinessOp } from "../components/ImageBusinessOp";

const MultipleEditor: React.FC = () => {
  const lang = langStore.tgt;
  const multipleData = useSelecting("multiple");
  const { setGroup } = multipleData ?? {};

  return !multipleData ? null : (
    <SubEditorPanel w="100%" panelTitle={translate("multi-node-panel-title", lang)}>
      <Center w="100%" pl="20px" pr="20px" flexDirection="column" mt="12px" gap="24px">
        <Button w="100%" onClick={setGroup} variant="outline">
          {translate("grouping", lang)}
        </Button>
        <ImageBusinessOp />
      </Center>
    </SubEditorPanel>
  );
};

export default observer(MultipleEditor);
